import createemprecord from "./createemprecord"
import createrole from "./createrole";
import hr21 from "./hr21";
import hr22 from "./hr22";

export default {
    createemprecord,
    createrole,
    hr21,
    hr22
}